<template>
  <div v-if="tickets.length" class="ticket-warning">
    <div class="warning-header">
      <i class="el-icon-warning warning-color" />
      <span class="warning-title">课次券提示</span>
    </div>

    <p class="warning-msg warning-color">{{ message }}</p>

    <!-- 桌面端：表格布局 -->
    <div class="ticket-table">
      <div class="ticket-table-header">
        <span class="col-type">课次券类型</span>
        <span class="col-status">状态</span>
        <span class="col-expire">失效时间</span>
        <span class="col-remain">剩余次数</span>
      </div>
      <div
        v-for="ticket in tickets"
        :key="ticket.id"
        class="ticket-table-row"
      >
        <span class="col-type">
          <router-link :to="RouteConfig.cardTicketDetail.to(ticket.id)" class="primary-color">
            {{ ticket.card_ticket_type_name }}
          </router-link>
        </span>
        <span class="col-status">
          <span :class="ticket.effect_time ? 'success-color' : 'warning-color'">
            {{ ticket.effect_time ? '已生效' : '待生效' }}
          </span>
        </span>
        <span class="col-expire">{{ formatTime(ticket) }}</span>
        <span class="col-remain">{{ formatNumber(ticket) }}</span>
      </div>
    </div>

    <!-- 移动端：卡片布局 -->
    <div class="ticket-cards">
      <div
        v-for="ticket in tickets"
        :key="ticket.id"
        class="ticket-card"
      >
        <div class="card-row">
          <span class="card-label">课次券类型：</span>
          <router-link :to="RouteConfig.cardTicketDetail.to(ticket.id)" class="primary-color">
            {{ ticket.card_ticket_type_name }}
          </router-link>
        </div>
        <div class="card-row">
          <span class="card-label">状态：</span>
          <span :class="ticket.effect_time ? 'success-color' : 'warning-color'">
            {{ ticket.effect_time ? '已生效' : '待生效' }}
          </span>
        </div>
        <div class="card-row">
          <span class="card-label">失效时间：</span>
          <span>{{ formatTime(ticket) }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">剩余次数：</span>
          <span>{{ formatNumber(ticket) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { timeToYmd, toYuan } from '@/filters';

export default {
  name: 'VCardTicketWarning',
  props: {
    tickets: {
      type: Array,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    RouteConfig,
  }),
  methods: {
    formatTime(ticket) {
      return ticket.expire_time ? timeToYmd(ticket.expire_time) : '未开券';
    },
    formatNumber(ticket) {
      return toYuan(ticket.expire_number) + ' 次';
    },
  },
};
</script>

<style scoped>
.ticket-warning {
  width: 100%;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 6px;
  padding: 14px 18px;
  margin-bottom: 18px;
  box-sizing: border-box;
}

.warning-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
}

.warning-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.warning-msg {
  margin: 0 0 12px 0;
  font-size: 13px;
  line-height: 1.6;
}

/* ========== 桌面端表格 ========== */
.ticket-table {
  display: block;
  border: 1px solid #fde2e2;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.ticket-table-header,
.ticket-table-row {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 0.9fr;
  gap: 12px;
  padding: 8px 14px;
  font-size: 13px;
  align-items: center;
}

.ticket-table-header {
  background: #fdf6f6;
  color: #909399;
  font-weight: 600;
  border-bottom: 1px solid #fde2e2;
}

.ticket-table-row {
  color: #606266;
  border-bottom: 1px solid #fef0f0;
}

.ticket-table-row:last-child {
  border-bottom: none;
}

.col-type {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.col-status,
.col-expire,
.col-remain {
  text-align: center;
}

/* ========== 移动端卡片（默认隐藏） ========== */
.ticket-cards {
  display: none;
}

.ticket-card {
  background: #fff;
  border: 1px solid #fde2e2;
  border-radius: 4px;
  padding: 10px 12px;
  margin-bottom: 8px;
}

.ticket-card:last-child {
  margin-bottom: 0;
}

.card-row {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #606266;
  padding: 3px 0;
}

.card-label {
  flex-shrink: 0;
  color: #909399;
  width: 80px;
}

/* ========== 响应式 ========== */
@media (max-width: 768px) {
  .ticket-warning {
    padding: 12px 14px;
  }

  .ticket-table {
    display: none;
  }

  .ticket-cards {
    display: block;
  }
}
</style>
